import apiService from "./BaseApi";

const EmailService = {
    sendEmail: async (data) => apiService.post("", data),
};

export default EmailService;
